if (!customElements.get("cart-reviews")) {
  class CartReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      const sliderEl = this.querySelector(".cart-reviews-slider");
      const sliderNav = this.closest('.cart-reviews').querySelector(".cart-reviews__header");
      if (!sliderEl) return;

      const nextEl = sliderNav.querySelector(".cart-reviews__arrow--next");
      const prevEl = sliderNav.querySelector(".cart-reviews__arrow--prev");
      this.swiper = new Swiper(sliderEl, {
        slidesPerView: 1.1,
        spaceBetween: 16,
        freeMode: false,
        cssMode: true,

        navigation: {
          nextEl,
          prevEl,
        },

        breakpoints: {
          1024: {
            slidesPerView: 1.27,
          },
        },
      });
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("cart-reviews", CartReviewsSlider);
}
